// extracted by mini-css-extract-plugin
export default {"root":"allAttachesButton__root--3x3ys","icon":"allAttachesButton__icon--2vZK_","tip":"allAttachesButton__tip--6j2oI","text":"allAttachesButton__text--3RfJd"};